const EMPTY_OBJECT = {}

const resultFunction = (data, activeWalletAccount) => data?.[activeWalletAccount] || EMPTY_OBJECT

const inActiveAccountSelector = {
  id: 'inActiveAccount',
  resultFunction,
  dependencies: [
    //
    { selector: 'data' },
    { module: 'walletAccounts', selector: 'active' },
  ],
}

export default inActiveAccountSelector
